import { render } from "./academy-en.vue?vue&type=template&id=7f1520ce&scoped=true"
import script from "./academy-en.vue?vue&type=script&lang=js"
export * from "./academy-en.vue?vue&type=script&lang=js"

import "./academy-en.vue?vue&type=style&index=0&id=7f1520ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1520ce"]])

export default __exports__